<script setup lang="ts">
import KTextField from '@/components/fields/KTextField.vue';
</script>

<template>
  <KTextField
    size="lg"
    label="Password"
    name="password"
    type="password"
    data-testid="passwordField"
  />
</template>
